const host = 'https://g.zbanx.com';

export const createOssAssetsUrl = (pathname: string) => {
  if (typeof pathname === 'string') {
    return `${host}/${pathname.replace(/^\/+/g, '')}`;
  }
  return host;
};
